var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lung-sound-check"},[_c('md-chip',{staticClass:"md-primary"},[_vm._v("If lung sounds were checked")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }